import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { applyAuthenticatedSession } from 'lib/auth';
import { Alert, Button } from 'components/common';
import { Form, FormGroup, Text } from 'components/common/form';

const LDAPLogin = connect((state) => state)(
  class extends Component {
    state = {
      error: null,
      loading: false
    };

    componentDidMount() {
      if (this.props.isOpen) {
        this.inputContainer?.querySelector('input').focus();
      }
    }

    componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        this.inputContainer?.querySelector('input').focus();
      }
    }

    handleOpen = () => {
      this.props.onOpenClick(this.props.strategy.name);
    };

    handleSubmit = async (values) => {
      const {
        dispatch,
        messages,
        next,
        onSuccess,
        sessionUserEmail,
        strategy
      } = this.props;

      try {
        this.setState({ error: null, loading: true });
        const response = await api.post(`/auth/${strategy.name}/authenticate`, {
          email: sessionUserEmail || values.email,
          password: values.password
        });
        if (response.data?.success) {
          await applyAuthenticatedSession({
            dispatch,
            user: response.data.user
          });
          if (onSuccess) {
            onSuccess();
          } else {
            window.location.href = next || '/';
          }
        } else {
          let error = messages.commonError;
          if (response.data) {
            if (
              response.data.error === 'user_not_found' ||
              response.data.error === 'Invalid username/password'
            ) {
              error = messages.authSignInError;
            } else if (response.data.error === 'account_expired') {
              error = messages.authAccountExpired;
            } else if (response.data.error === 'account_locked') {
              error = messages.authAccountLocked;
            }
          }
          this.setState({ error, loading: false });
        }
      } catch (err) {
        this.setState({
          error: messages.commonError,
          loading: false
        });
      }
    };

    render() {
      const {
        isOpen,
        messages,
        registration,
        pageState: { user },
        sessionUserEmail,
        strategy,
        theme
      } = this.props;

      const { error, loading } = this.state;

      if (!isOpen) {
        return (
          <div className="open-button">
            <Button
              onClick={this.handleOpen}
              text={
                registration
                  ? strategy.buttonTextRegister || strategy.name
                  : strategy.buttonText || strategy.name
              }
            />

            <style jsx>{`
              .open-button :global(button) {
                background-color: ${strategy.buttonColor || theme.mainColor};
                margin-top: 15px;
                width: 100%;
              }
              .open-button :global(button:hover) {
                background-color: ${strategy.buttonHoverColor ||
                theme.mainColorActive};
              }
            `}</style>
          </div>
        );
      }

      return (
        <div className="login-form">
          <Form onSubmit={this.handleSubmit}>
            {!sessionUserEmail ? (
              <FormGroup for="email" label={messages.commonEmail}>
                <Text
                  disabled={registration && user?.email}
                  field="email"
                  id="email"
                  initialValue={registration && user?.email ? user.email : ''}
                  inputContainerRef={(el) => (this.inputContainer = el)}
                  type="text"
                />
              </FormGroup>
            ) : null}
            <FormGroup for="password" label={messages.commonPassword}>
              <Text field="password" id="password" type="password" />
            </FormGroup>

            {error ? (
              <Alert className="login-error" text={error} type="error-light" />
            ) : null}

            <Button
              category="success"
              loading={loading}
              text={strategy.buttonText || strategy.name}
              type="submit"
            />
          </Form>

          <style jsx>{`
            .login-form :global(button),
            .login-form :global(button:disabled) {
              background-color: ${strategy.buttonColor || theme.mainColor};
              margin-top: 20px;
              width: 100%;
            }
            .login-form :global(button:hover),
            .login-form :global(button:disabled:hover) {
              background-color: ${strategy.buttonHoverColor ||
              theme.mainColorActive} !important;
            }
            .login-form :global(.login-error) {
              margin-top: 20px;
            }
            .forgot-password {
              font-size: 1.4rem;
              margin-top: 15px;
              text-align: center;
            }
            .register {
              font-size: 1.4rem;
              margin-top: 10px;
              text-align: center;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default LDAPLogin;
